import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ConfirmationModalForUpload({ onOpen, toggle, data, handleCheckboxChange, handleNoButtonClick, handleYesButtonClick }) {
  const { t } = useTranslation('common');

  return (
    <Modal
      className="common-custom-modal modal-medium"
      aria-labelledby="contained-modal-title-vcenter"
      size="lg"
      show={onOpen}
      onHide={toggle}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>{t('POMS.GRADING_GROUP.MODAL_DOWNLOAD.EXCEL_POM_IMPORTS')}</Modal.Title>
        <span onClick={() => handleNoButtonClick()} className="icon-close" />
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{t('POMS.GRADING_GROUP.MODAL_DOWNLOAD.WOULD_U_LIKE_POM_MESSAGE')}</p>

          <div className="common-checkbox">
            <input type="checkbox" id="vehicle1" name="vehicle1" checked={data?.isChecked} onChange={() => handleCheckboxChange()} />
            <label htmlFor="vehicle1" className="chklabel">
              <span className="f-16 font-medium">{t('POMS.GRADING_GROUP.MODAL_DOWNLOAD.CURRENT_POM_MESSAGE')}</span>
            </label>
          </div>
        </div>
        <div className="common-model-footer">
          {/* <button className="btn btn-default" type="button" onClick={() => handleNoButtonClick()}>
            {t("POMS.GRADING_GROUP.MODAL_DOWNLOAD.NO")}
          </button> */}
          <button aria-label="save" className="btn p-0" type="button" onClick={() => handleYesButtonClick()}>
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmationModalForUpload;
